import React, { useState } from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';

const SAMPLE_PHOTOS = [
  'https://images.unsplash.com/photo-1518610464364-5e0e0e0e0e0e?w=400&h=400&fit=crop',
  'https://images.unsplash.com/photo-1529634806937-81e9f91f3b5c?w=400&h=400&fit=crop',
  'https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?w=400&h=400&fit=crop',
];

const CouplesPhoto = ({ data, onNext }) => {
  const [photoUrl, setPhotoUrl] = useState(data.photoUrl || '');
  const [selectedSample, setSelectedSample] = useState('');

  const handleSampleSelect = (url) => {
    setSelectedSample(url);
    setPhotoUrl(url);
  };

  const handleSubmit = () => {
    onNext({ photoUrl });
  };

  return (
    <motion.div initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} className="p-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-1">Add a Photo Moment 📸</h2>
      <p className="text-gray-500 text-sm mb-6">Include a special memory together</p>

      <div className="space-y-5">
        {/* Upload area */}
        <div className="border-2 border-dashed border-purple-200 rounded-2xl p-8 text-center bg-purple-50/30">
          {photoUrl ? (
            <div className="relative">
              <img src={photoUrl} alt="Selected" className="w-40 h-40 object-cover rounded-2xl mx-auto shadow-lg" />
              <button
                onClick={() => { setPhotoUrl(''); setSelectedSample(''); }}
                className="absolute top-0 right-1/2 translate-x-[72px] -translate-y-2 w-8 h-8 bg-red-500 text-white rounded-full flex items-center justify-center shadow-lg"
              >
                <SafeIcon name="X" className="text-sm" />
              </button>
            </div>
          ) : (
            <>
              <SafeIcon name="Camera" className="text-4xl text-purple-300 mx-auto mb-3" />
              <p className="text-sm text-purple-500 font-medium mb-1">Add a photo</p>
              <p className="text-xs text-gray-400">Choose from samples below</p>
            </>
          )}
        </div>

        {/* Sample photos */}
        <div>
          <p className="text-xs text-gray-400 font-semibold uppercase mb-3">Sample Photos</p>
          <div className="grid grid-cols-3 gap-3">
            {SAMPLE_PHOTOS.map((url, i) => (
              <button
                key={i}
                onClick={() => handleSampleSelect(url)}
                className={`aspect-square rounded-xl overflow-hidden border-2 transition-all ${
                  selectedSample === url ? 'border-purple-500 shadow-lg' : 'border-transparent'
                }`}
              >
                <img src={url} alt={`Sample ${i + 1}`} className="w-full h-full object-cover" />
              </button>
            ))}
          </div>
        </div>

        <div className="bg-amber-50 border border-amber-100 rounded-xl p-3 flex items-center gap-2">
          <span className="text-amber-500">✨</span>
          <p className="text-xs text-amber-700">Upload your own photos with DayClap Premium</p>
        </div>

        <button onClick={handleSubmit}
          className="w-full bg-gradient-to-r from-purple-500 to-violet-500 text-white font-bold py-4 rounded-xl shadow-lg shadow-purple-200">
          {photoUrl ? 'Continue →' : 'Skip — No Photo'}
        </button>
      </div>
    </motion.div>
  );
};

export default CouplesPhoto;